import { DeviceSensor } from '../../Common/Types/cloudApi';

const WAITING_FOR_DEVICE = 'Waiting for device...';
const NOT_YET_REPORTED = 'Not yet reported';

export function getNoSensorsText(sensors: DeviceSensor['sensors']) {
  return sensors.length > 0 ? NOT_YET_REPORTED : WAITING_FOR_DEVICE;
}
